import { memo, useEffect } from "react";
import { useAtomValue, useSetAtom } from "jotai";
import { currentProjectAtom } from "~/stores/ProjectStore";
import { isMapLoadedDoneAtom } from "../stores/mapStore";
import { projectMembersWithRolesAsyncAtom, projectMembersWithRolesAtom } from "../Member/MemberStore";

/**
 * ProjectMemberController
 * Tự động tải và nạp danh sách thành viên dự án (projectMembersWithRoles)
 * khi bản đồ tải xong hoặc khi project thay đổi, phục vụ hiển thị tên/avatar
 * người chụp ảnh tự do, người thu thập và bộ lọc thành viên.
 */
const ProjectMemberController = () => {
  const currentProject = useAtomValue(currentProjectAtom);
  const isMapLoadedDone = useAtomValue(isMapLoadedDoneAtom);
  const fetchMembers = useSetAtom(projectMembersWithRolesAsyncAtom);
  const setMembers = useSetAtom(projectMembersWithRolesAtom);

  useEffect(() => {
    if (!isMapLoadedDone || !currentProject?.id) {
      if (!currentProject?.id) {
        setMembers([]);
      }
      return;
    }

    fetchMembers();
  }, [isMapLoadedDone, currentProject?.id, fetchMembers, setMembers]);

  return null;
};

export default memo(ProjectMemberController);
